import React from 'react'
import UserProfileCard from '../lesson17/UserProfileCard';

class UserProfileClass extends React.Component {
    constructor(props) {
        super(props);
        this.state = { userData: null };
    }

    componentDidMount() {
        fetch('https://dummyjson.com/user/' + this.props.userID)
            .then(response => response.json())
            .then(data => this.setState({ userData: data }));
    }

    componentDidUpdate(prevProps) {
        if (this.props.userID !== prevProps.userID) {
            this.fetchData();
        }
    }

    componentWillUnmount() {
        console.log('Cleaning up...');
    }

    render() {
        const { userData } = this.state;
        return (
            <div>
                {userData ? (
                    <div>
                        <h1>{userData.firstName} {userData.lastName}</h1>
                        <p>{userData.email}</p>
                    </div>
                ) : (
                    <p>Loading...</p>
                )}
            </div>
        );
    }
}

export default UserProfileClass